import './App.css';
import StockMovePage from './pages/StockMovePage';

function App() {
  return (
    <StockMovePage />
  );
}

export default App;
